export default __webpack_public_path__ + "media/images/36-9d5f59f02db80114b0006535025850e9.png";